// import App from '../../assets/js/app';


export default class DashboardSonos {

	static selector = 'dashboard-sonos';

	el = {};

	watching = 'Basic Pit';

	currentTrack = null;

	constructor(container) {
		this.el = {
			container,
			coverImage: container.querySelector(`.${this.constructor.selector}__cover-image`),
			trackTitle: container.querySelector(`.${this.constructor.selector}__track-title`),
			trackArtist: container.querySelector(`.${this.constructor.selector}__track-artist`)
		};

		// fetch('https://app.basicagencydev.com/sonos')
		// 	.then((response) => response.json())
		// 	.then((results) => {
		// 		console.log(results);
		// 		this.updateTrack(results[0]);
		// 	});

		this.addEventListeners();
	}

	updateTrack(track) {
		if (track.uri !== this.currentTrack) {
			this.currentTrack = track.uri;
			this.el.coverImage.innerHTML = `<img src="${track.albumArtURI}">`;
			this.el.trackTitle.innerText = track.title;
			this.el.trackArtist.innerText = track.artist;
		}
	}

	updateState(state) {
		this.el.container.classList[state === 'playing' ? 'add' : 'remove']('is-playing');
	}

	onSonosPlayState = (data) => {
		if (data.description.roomName === this.watching) {
			if (data.track.title) {
				this.updateState(data.state);
				this.updateTrack(data.track);
			}
		}
	};

	onSonosCurrentTrack = (data) => {
		if (data.description.roomName === this.watching) {
			if (data.track.title) this.updateTrack(data.track);
			this.updateState(data.state);
		}
	};

	addEventListeners() {
		// App.socket.on('sonos.playState', this.onSonosPlayState);
		// App.socket.on('sonos.currentTrack', this.onSonosCurrentTrack);
	}

	removeEventListeners() {
		// App.socket.off('sonos.playState', this.onSonosPlayState);
		// App.socket.off('sonos.currentTrack', this.onSonosCurrentTrack);
	}

	destroy() {
		this.removeEventListeners();
	}

}
